import { createFileRoute } from '@tanstack/react-router'
import { AuditLogPage } from '../../../features/admin/AuditLogPage'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin/audit-log')({
  component: AdminAuditLogRoute,
})

/* ───── Route Component ───── */

function AdminAuditLogRoute() {
  return <AuditLogPage />
}
